import { ScheduleCourse } from './builders/course_builder';
import { DisplayDataBuilderFunction } from './builders/display_data_builder';
import {
  MyScheduleCourseController,
  ScheduleCourseComponent
} from './components/my_schedule_course/my_schedule_course_controller';
import {
  MyScheduleCourseListController,
  ScheduleCourseListComponent
} from './components/my_schedule_course_list/my_schedule_course_list_controller';
import { MyScheduleDetailController } from './components/my_schedule_detail/my_schedule_detail_controller';
import { MyScheduleListController } from './components/my_schedule_list/my_schedule_list_controller';
import {
  SectionLabelBadgeComponent,
  SectionLabelBadgeController
} from './components/section_label_badge/section_label_badge_controller';
import { CourseScheduleLocalDatabase } from './databases/course_schedule_database';
import { MyScheduleDetailFunction } from './functions/my_schedule_detail_fn';
import { MyScheduleHelperFunction } from './functions/my_schedule_fn';
import { MyScheduleNativeCalenderFunction } from './functions/my_schedule_native_calendar_fn';
import { ScheduleQuery } from './queries/schedule_query';
import { CalendarIntegrationService } from './services/calendar_integration_service';

import { MyScheduleDetailComponent } from './components/my_schedule_detail/my_schedule_detail_component';
import { MyScheduleListComponent } from './components/my_schedule_list/my_schedule_list_component';
import { CourseScheduleCapabilityConfiguration } from './configuration';
import { ScheduleRoutes } from './routes';
import { MyScheduleDetailViewController } from './views/my_schedule_detail_view/my_schedule_detail_view_controller';
import { MyScheduleListViewController } from './views/my_schedule_list_view/my_schedule_list_view_controller';

angular
  .module('capability-ng-course-schedule', [])

  .factory('myScheduleDetailFn', MyScheduleDetailFunction.build)
  .factory('myScheduleHelperFn', MyScheduleHelperFunction.build)
  .factory('myScheduleNativeCalendarFn', MyScheduleNativeCalenderFunction)
  .factory('DisplayDataBuilder', DisplayDataBuilderFunction)
  .factory('CourseBuilder', () => {
    return {
      $get: (data: any) => new ScheduleCourse(data)
    };
  })

  .service('ngScheduleQuery', ScheduleQuery)
  .service('ngCalendarIntegrationService', CalendarIntegrationService)

  .controller('MyScheduleCourseController', MyScheduleCourseController)
  .controller('MyScheduleCourseListController', MyScheduleCourseListController)
  .controller('MyScheduleListController', MyScheduleListController)
  .controller('MyScheduleDetailController', MyScheduleDetailController)
  .controller('SectionLabelBadgeController', SectionLabelBadgeController)

  .component('scheduleCourse', new ScheduleCourseComponent())
  .component('scheduleCourseList', new ScheduleCourseListComponent())
  .component('myScheduleList', new MyScheduleListComponent())
  .component('myScheduleDetail', new MyScheduleDetailComponent())
  .component('sectionLabelBadge', new SectionLabelBadgeComponent())

  .controller('MyScheduleDetailViewController', MyScheduleDetailViewController)
  .controller('MyScheduleListViewController', MyScheduleListViewController)

  .service('ngCourseScheduleCapabilityConfiguration', CourseScheduleCapabilityConfiguration)

  .config(ScheduleRoutes);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/capability-ng-course-schedule-module.ts